// import './reviews-carousel.css';
import Splide from '@splidejs/splide';
import '@splidejs/splide/dist/css/splide-core.min.css';

export default function init(element) {
  console.log('Initializing Reviews Carousel with Splide on:', element);

  const numberOfReviews = element.querySelectorAll('.splide__slide');

  // Don't initialize slider if only 1 review
  if (numberOfReviews.length <= 1) return;

  // Initialize Splide
  const carousel = new Splide(element, {
    type: 'loop',
    perPage: 1,
    autoplay: false,
    speed: 450,
    easing: 'ease-in-out',
    pagination: true,
    classes: {
      pagination: 'splide__pagination',
      page      : 'splide__pagination__page',
    },
  });

  carousel.mount();
}
